import { render, staticRenderFns } from "./AboutDialog.vue?vue&type=template&id=644a4763"
import script from "./AboutDialog.vue?vue&type=script&lang=js"
export * from "./AboutDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports